// store/authStore.js
import { create } from "zustand";
import { getBannerData } from "../api/home";
import { getUtilityData } from "../api/utility";

export const useUtilityStore = create((set, get) => ({
    loading: true,
    banner: null,
    utility: [],

    getBanner: async () => {
        try {
            set({ loading: true })
            const res = await getBannerData('utilities')
            set({ loading: false, banner: res })
            return res
        } catch (error) {
            console.log("Error in checkAuth:", error);
            set({ authUser: null, hasTriedAuth: true });
            return false;
        } finally {
            set({ isCheckingAuth: false, hasTriedAuth: true });
        }
    },
    getUtility: async (pageNumber, pageSize, search, field) => {
        try {
            set({ loading: true })
            const res = await getUtilityData(pageNumber, pageSize, search, field)
            console.log(res?.ref)
            set({ loading: false, utility: res?.ref })
            return res
        } catch (error) {
            console.log("Error in checkAuth:", error);
            set({ authUser: null, hasTriedAuth: true });
            return false;
        } finally {
            set({ isCheckingAuth: false, hasTriedAuth: true });
        }
    }

}));
